var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.81818 8.72729C4.81818 8.17501 5.26589 7.72729 5.81818 7.72729H26.1818C26.7341 7.72729 27.1818 8.17501 27.1818 8.72729C27.1818 9.27958 26.7341 9.72729 26.1818 9.72729H5.81818C5.26589 9.72729 4.81818 9.27958 4.81818 8.72729ZM4.81818 16C4.81818 15.4477 5.26589 15 5.81818 15H26.1818C26.7341 15 27.1818 15.4477 27.1818 16C27.1818 16.5523 26.7341 17 26.1818 17H5.81818C5.26589 17 4.81818 16.5523 4.81818 16ZM5.81818 22.2727C5.26589 22.2727 4.81818 22.7204 4.81818 23.2727C4.81818 23.825 5.26589 24.2727 5.81818 24.2727H26.1818C26.7341 24.2727 27.1818 23.825 27.1818 23.2727C27.1818 22.7204 26.7341 22.2727 26.1818 22.2727H5.81818Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.f62cac27bd889b292e7759416bc53c9d.svg";
export { ForwardRef as ReactComponent };